//@flow

export const ParentEnum = Object.freeze({
  'firstParent': 'firstParent',
  'secondParent': 'secondParent'
})
